import {observer} from "mobx-react";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";
import {
    Container,
    ContainerInputSearch,
    Content,
    ContentInputSearch,
    ContentLoading, ContentTextNoResults,
    Text
} from "@dropDesk/presentation/pages/chat/ui/internal_chat/list/styled";
import InternalChatList from "@dropDesk/presentation/components/internal_chat_list";
import LoadingInfinityScroll from "@dropDesk/presentation/components/loadings/loading_infinity_scroll";
import InputSearchGeneric from "@dropDesk/presentation/components/inputs/input_search";
import {SpinLoading} from "@dropDesk/presentation/components/loadings/spin";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ConstantsKeys} from "@dropDesk/domain/entities/constants/constants_keys";
import ButtonNewExpanded from "@dropDesk/presentation/components/buttons/button_new_expanded";

export const InternalChatLists = (observer((
    {
        internalChats,
        loading,
        hasMore,
        loadMore,
        useSearch,
        onSearch,
        searchParam,
        loadingMore,
        onClick,
        idInternalChatSelected,
        userLogged,
        disabled,
        onClickNewInternalChat
    }: {
        internalChats: InternalChatEntity[]
        loading: boolean
        loadingMore: boolean
        hasMore?: boolean
        useSearch?: boolean
        loadMore: () => void
        onSearch?: (value: string) => void
        searchParam: string
        idInternalChatSelected?: string | null
        onClick: (internalChat: InternalChatEntity) => void
        userLogged: UserEntity
        disabled: boolean
        onClickNewInternalChat: () => void
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    return (
        <Container bordercolor={colors.border}>
            {useSearch &&
                <ContainerInputSearch>
                    <ContentInputSearch>
                        <InputSearchGeneric
                            inputSearchPlaceholder="Pesquisar por descrição"
                            loading={loading}
                            onSearch={(value) => onSearch ? onSearch(value) : () => {
                            }}
                            size={'large'}
                            defaultLimitInputSearch={ConstantsKeys.defaultNewLimitInputSearch}
                        />
                    </ContentInputSearch>
                    <ButtonNewExpanded
                        onClick={() => onClickNewInternalChat()}
                        loading={false}
                        tooltip={'Criar novo chat interno'}
                    />
                </ContainerInputSearch>
            }
            <Content>
                {loading && internalChats.length === 0 &&
                    <ContentLoading>
                        <SpinLoading
                            size={"large"}
                            color={colors.text}
                            tip={"Carregando ..."}
                        />
                    </ContentLoading>
                }
                {!loading && internalChats.length === 0 &&
                    <ContentTextNoResults>
                        <DropDeskIcon icon={ICONS_DROPDESK.emptyFolder} size={55} color={colors.hintInverse}/>
                        <Text color={colors.text}>Nenhuma conversa interna encontrada.</Text>
                    </ContentTextNoResults>
                }

                {internalChats.map((internalChat) => {
                    return (
                        <InternalChatList
                            key={internalChat.id}
                            onClick={() => onClick(internalChat)}
                            internalChat={internalChat}
                            searchParam={searchParam}
                            idInternalChatSelected={idInternalChatSelected}
                            userLogged={userLogged}
                            disabled={disabled}
                        />
                    )
                })}
                {hasMore &&
                    <LoadingInfinityScroll
                        loading={loadingMore}
                        loadMore={() => loadMore()}
                        label={'Carregar mais conversas'}
                        labelLoading={'Carregando mais conversas...'}
                    />}

            </Content>
        </Container>
    )
}));
